// extracted by mini-css-extract-plugin
export default {"melodyVideo":"vO-z","isFullWidth":"wO-z","landingPageVideo":"xO-z","play":"yO-z","iframeVideo":"zO-z","playHidden":"AO-z","fullwidth":"BO-z"};